import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resolveDday, resolveFullImage } from './CampaignCard';
import styles from './HeroBanner.module.css';

const STATUS_LABEL = {
  RECRUITING: '모집중',
  PENDING: '오픈 예정',
  SELECTION_IN_PROGRESS: '선정중',
  REVIEW_IN_PROGRESS: '리뷰중',
  COMPLETED: '마감',
};

function ddayText(dday) {
  if (dday === null || dday === undefined) return null;
  if (dday < 0) return '모집 마감';
  if (dday === 0) return '오늘 마감';
  return `마감까지 ${dday}일`;
}

export default function HeroBanner({ campaign }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const { id, title, brandName, recruitCount, status } = campaign;
  const thumbnail = resolveFullImage(campaign);
  const dday = resolveDday(campaign);
  const closed = status === 'COMPLETED';
  const deadline = ddayText(dday);

  return (
    <Link className={styles.hero} to={`/campaign/${id}`}>
      {thumbnail && !failed ? (
        <img
          className={`${styles.img}${loaded ? ` ${styles.imgLoaded}` : ''}`}
          src={thumbnail}
          alt={title}
          decoding="async"
          fetchPriority="high"
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      ) : (
        <div className={`${styles.img} ${styles.imgFallback}`} />
      )}

      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={`${styles.badge} ${closed ? styles.badgeClosed : ''}`}>
          <span className={styles.dot} />
          {STATUS_LABEL[status] ?? '모집중'}
        </div>
        {brandName && <p className={styles.brand}>{brandName}</p>}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.meta}>
          {[recruitCount ? `${recruitCount}명 모집` : null, deadline].filter(Boolean).join(' · ')}
        </p>
      </div>
    </Link>
  );
}
